import type { Role } from '@/types'

const PARCEIROS_READ_ROLES: Role[] = ['admin', 'manager', 'closer']
const PARCEIROS_WRITE_ROLES: Role[] = ['admin', 'manager', 'closer']
const PARCEIROS_DELETE_ROLES: Role[] = ['admin']
const PARCEIROS_COMMISSION_ROLES: Role[] = ['admin', 'manager']

/** Perfis que podem listar parceiros na API (espelha authorize no backend). */
export function canReadParceiros(role: Role | string | null | undefined): boolean {
  if (!role) return false
  return PARCEIROS_READ_ROLES.includes(role.toLowerCase() as Role)
}

/** Cadastrar e editar parceiros (comercial operacional — ex.: Sophia). */
export function canWriteParceiros(role: Role | string | null | undefined): boolean {
  if (!role) return false
  return PARCEIROS_WRITE_ROLES.includes(role.toLowerCase() as Role)
}

/** Exclusão permanente — apenas admin. */
export function canDeleteParceiros(role: Role | string | null | undefined): boolean {
  if (!role) return false
  return PARCEIROS_DELETE_ROLES.includes(role.toLowerCase() as Role)
}

/** Registrar pagamento (repasse) a parceiros — apenas admin, espelha o backend. */
export function canRegisterPartnerPayments(role: Role | string | null | undefined): boolean {
  return role?.toLowerCase() === 'admin'
}

/** Encerrar/reabrir recorrência e recalcular comissões (espelha authorize no backend). */
export function canManagePartnerCommissions(role: Role | string | null | undefined): boolean {
  if (!role) return false
  return PARCEIROS_COMMISSION_ROLES.includes(role.toLowerCase() as Role)
}
